import { Box } from '@mui/material';
import { LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer } from 'recharts';

const TimelineGraph = ({ data, loading }) => {

    return (
        loading ? <Box sx={{ textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>Chargement...</Box> :

        <ResponsiveContainer width="100%" height={300}>
        <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="_id" />
            <YAxis />
            <Tooltip />
            <Line type="monotone" dataKey="recette" stroke="#8884d8" name="Recette (€)" />
            <Line type="monotone" dataKey="count" stroke="#82ca9d" name="Nombre de billets" />
        </LineChart>
        </ResponsiveContainer>
    );
};

export default TimelineGraph;